import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import {
  FormModeEnum,
  TableActionParams,
  NotificationService,
  ModalService,
  BackendService,
} from 'beyond-util';
import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';

@Component({
  selector: 'app-odluke',
  templateUrl: './odluke.component.html',
})
export class OdlukeComponent extends SifarnikBase implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  private _data: Array<any>;
  public showDetails = false;

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  changeName() {
    if (typeof this.order === 'undefined') {
      return;
    }

    if (this.order.hasOwnProperty('naziv')) {
      this.name = this.order.naziv;
    } else if (this.mode === FormModeEnum.Add) {
      this.name = 'Nova odluka';
    } else if (this.order.hasOwnProperty('id')) {
      this.name = 'Odluka';
    }
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSCEN_ODL,
          FormName.SifarnikOdluka,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          if (!this.settingsTable) {
            this.setSettings(data['Settings']);
          }
          this._data = data['ServiceData'];
          this.setAllFields();
          this.refreshTable();
        })
    );
  }

  refreshTable() {
    const data = {
      documentId: 'USERS',
      result: this._data,
      pageSize: 10,
      pageNumber: 1,
      count: this._data.length,
      menuCalled: false,
      error: 0,
    };
    this.orderList = data.result;
    this.setRbr(this.orderList);
  }

  addOrder() {
    this._subscriptions.push(
      this._rtsBackendService
        .save(FormCode.MSCEN_ODL, FormName.SifarnikOdluka, this.order)
        .subscribe(() => {
          this.loadSettings();
        })
    );
  }

  updateOrder() {
    this._subscriptions.push(
      this._rtsBackendService
        .update(FormCode.MSCEN_ODL, FormName.SifarnikOdluka, this.order)
        .subscribe(() => {
          this.loadSettings();
        })
    );
  }

  onDeleteConfirm() {
    this._subscriptions.push(
      this._rtsBackendService
        .delete(FormCode.MSCEN_ODL, FormName.SifarnikOdluka, this.order.Id)
        .subscribe(() => {
          this._notificationService.openNoty('Uspešno brisanje');
          this.loadSettings();
        })
    );
  }

  onTableActionUpdate(event: TableActionParams) {
    super.onTableActionUpdate(event);
    this.updateOrder();
  }

  onTableInlineSave() {
    this.addOrder();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/odluke/odluke.component.ts